import http from "../axios/http-common";

class InterfaceResep {
  // riwayat sidebar
  getAllTransaksiResep(reg) {
    return http.getData(`/resep-farmasi/${reg}`);
  }
  getTransaksiResep(no_trans, tgl) {
    return http.getData(`/transaksi-farmasi/${no_trans}/${tgl}`);
  }
}
export default new InterfaceResep();
